// Support V1: agent-workspace API wrapper (/support-workspace/*).
// Thin wrappers only, matching lib/fleetCalendar.js's shape: no client-side
// caching beyond what the calling component's own useState holds.
import { api } from "./api";

export const myAgentProfile = () => api.get("/support-workspace/me/agent-profile").then((r) => r.data);

export const listCases = (params) => api.get("/support-workspace/cases", { params }).then((r) => r.data);
export const getCase = (id) => api.get(`/support-workspace/cases/${id}`).then((r) => r.data);
export const replyToCase = (id, text, attachmentIds = []) =>
  api.post(`/support-workspace/cases/${id}/reply`, { text, attachment_ids: attachmentIds }).then((r) => r.data);
export const addInternalNote = (id, text) =>
  api.post(`/support-workspace/cases/${id}/internal-notes`, { text }).then((r) => r.data);
export const assignCase = (id, agentId) =>
  api.post(`/support-workspace/cases/${id}/assign`, { agent_id: agentId }).then((r) => r.data);
export const setPriority = (id, priority) =>
  api.post(`/support-workspace/cases/${id}/priority`, { priority }).then((r) => r.data);
export const setCategory = (id, category, productArea) =>
  api.put(`/support-workspace/cases/${id}/category`, { category, product_area: productArea }).then((r) => r.data);
export const setStatus = (id, status) =>
  api.post(`/support-workspace/cases/${id}/status`, { status }).then((r) => r.data);
export const escalateCase = (id, level, extra = {}) =>
  api.post(`/support-workspace/cases/${id}/escalate`, { level, ...extra }).then((r) => r.data);
export const mergeCase = (primaryId, duplicateCaseId) =>
  api.post(`/support-workspace/cases/${primaryId}/merge`, { duplicate_case_id: duplicateCaseId }).then((r) => r.data);
export const caseAuditTrail = (id) => api.get(`/support-workspace/cases/${id}/audit`).then((r) => r.data);
export const uploadAgentAttachment = (id, payload) =>
  api.post(`/support-workspace/cases/${id}/attachments`, payload).then((r) => r.data);
export const getAgentAttachmentData = (caseId, attachmentId) =>
  api.get(`/support-workspace/cases/${caseId}/attachments/${attachmentId}/data`).then((r) => r.data);

export const listKnowledgeArticles = (status) =>
  api.get("/support-workspace/knowledge", { params: status ? { status } : {} }).then((r) => r.data);
export const createKnowledgeArticle = (payload) =>
  api.post("/support-workspace/knowledge", payload).then((r) => r.data);
export const updateKnowledgeArticle = (id, payload) =>
  api.put(`/support-workspace/knowledge/${id}`, payload).then((r) => r.data);

// AI Support V1: suggestion-only; never sends/mutates anything itself.
export const aiSuggestReply = (id) => api.post(`/support-workspace/cases/${id}/ai/suggest-reply`).then((r) => r.data);
export const aiSummarizeCase = (id) => api.post(`/support-workspace/cases/${id}/ai/summarize`).then((r) => r.data);
export const aiClassifyCase = (id) => api.post(`/support-workspace/cases/${id}/ai/classify`).then((r) => r.data);
export const aiKbSuggestions = (id) => api.get(`/support-workspace/cases/${id}/ai/kb-suggestions`).then((r) => r.data);
export const aiGetArtifacts = (id) => api.get(`/support-workspace/cases/${id}/ai/artifacts`).then((r) => r.data);

export const getAgentTerms = () => api.get("/support-workspace/agent-terms").then((r) => r.data);
export const acceptAgentInvite = (payload) =>
  api.post("/support-workspace/accept-invite", payload).then((r) => r.data);

// Platform-admin only (get_super_admin_user-gated on the backend).
export const inviteAgent = (payload) => api.post("/support-workspace/agents/invite", payload).then((r) => r.data);
export const listAgents = () => api.get("/support-workspace/agents").then((r) => r.data);
export const updateAgent = (id, payload) => api.put(`/support-workspace/agents/${id}`, payload).then((r) => r.data);
export const disableAgent = (id, reason) =>
  api.post(`/support-workspace/agents/${id}/disable`, { reason }).then((r) => r.data);

export const CASE_QUEUES = ["general", "technical", "account_recovery", "security"];
export const CASE_STATUSES = ["new", "open", "waiting_customer", "waiting_confirmph", "resolved", "closed"];
export const CASE_PRIORITIES = ["low", "normal", "high", "urgent"];
export const SUPPORT_CAPABILITIES = [
  "read_tickets", "reply", "assign", "close", "internal_notes", "priority",
  "merge", "business_read", "customer_read", "booking_read",
  "account_safe_read", "audit_read", "technical_escalation",
  "security_escalation", "restricted_security_read", "knowledge_suggestion",
  "macro_use", "ai_suggestions",
];
